import React from 'react';
import { fieldToTextField } from 'formik-material-ui';
import { Field } from 'formik';
import DateField from '../DateField';

const TField = (props) => (
    <DateField {...fieldToTextField(props)} {...props} type={'date'} />
);

const FormikDateField = (props) => {
    return <Field variant="outlined" {...props} component={TField} />;
};

export default FormikDateField;
